import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';

@Component({
  selector: 'app-vendor-referral-detail',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `<div class="tw-pb-4 tw-pt-6 tw-grow tw-w-full tw-min-w-0">
    <div class="tw-flex tw-gap-8">
      <div class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource">
          <app-detail-item label="Tax ID" name="taxID" labelCase="none" />
          <app-detail-item label="Contact Name" name="contactName" />
          <app-detail-item
            label="Service Interactivity"
            name="svcInteractivity"
          />
        </app-detail-panel>
      </div>
      <div class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource">
          <app-detail-item label="Method" name="method" />
          <app-detail-item label="Title" name="contactTitle" />
          <app-detail-item label="Referred To" name="providerName" />
          <app-detail-item label="Team" name="team" />
        </app-detail-panel>
      </div>
    </div>
    <app-detail-panel [dataSource]="dataSource" labelPosition="Top" class="">
      <app-detail-item label="Issue Details" name="issueDescription">
        <ng-template #value let-data>
          <div
            class="tw-whitespace-normal tw-w-full tw-min-w-0 tw-max-w-full"
            style="word-break: break-word; overflow-wrap: anywhere;"
          >
            {{ data.issueDescription }}
          </div>
        </ng-template>
      </app-detail-item>
    </app-detail-panel>
  </div> `,
  styles: [],
})
export class VendorReferralDetailComponent {
  @Input() dataSource: any;
}
